<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">{{storeName}}培训管理平台</span>
      </div>
    </div>
    <div class="toptitle">
      <div class="ttleft">
        <span>我的展示</span>
      </div>
      <div class="ttright">
        <img src="../../assets/img/icon/xuanzhong.png"
             alt="">
        <span v-show="boxIndex==1">已选择“VR展示”</span>
        <span v-show="boxIndex==2">已选择“图文展示”</span>
        <span v-show="boxIndex==3">已选择“视频展示”</span>
      </div>
    </div>
    <div class="topbox">
      <div class="box"
           @click="boxIndex=1"
           :style="boxIndex==1?'border: 1px solid #0B8586;':''">
        <div class="tblogo"
             :style="boxIndex==1?'background: #0B8586;':''">
          <img src="../../assets/img/store/VR.png"
               alt="">
        </div>
        <div class="tbtitle">
          <div></div>
          <span>VR展示</span>
          <div></div>
        </div>
      </div>
      <div class="box"
           @click="boxIndex=2"
           :style="boxIndex==2?'border: 1px solid #0B8586;':''">
        <div class="tblogo"
             :style="boxIndex==2?'background: #0B8586;':''">
          <img src="../../assets/img/store/图片.png"
               alt="">
        </div>
        <div class="tbtitle">
          <div></div>
          <span>图文展示</span>
          <div></div>
        </div>
      </div>
      <div class="box"
           @click="boxIndex=3"
           :style="boxIndex==3?'border: 1px solid #0B8586;':''">
        <div class="tblogo"
             :style="boxIndex==3?'background: #0B8586;':''">
          <img src="../../assets/img/store/视频.png"
               alt="">
        </div>
        <div class="tbtitle">
          <div></div>
          <span>视频展示</span>
          <div></div>
        </div>
      </div>
    </div>
    <div class="top2box"
         v-show="boxIndex==1">
      <span>如果您想选择VR展示形式，请联系视频发展部，进行现场的VR素材拍摄，具体联系方式详见...</span>
    </div>
    <div class="top3box"
         v-show="boxIndex!=1">
      <div class="t3box"
           @click="toUpdate">
        <span>编辑</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'usInfor',
  data () {
    return {
      storeName: '',
      boxIndex: 1
    };
  },
  created () {
    this.storeName = localStorage.getItem('storeName')
    this.getShow()
  },
  methods: {
    toUpdate () {
      if (this.boxIndex == 2) {
        this.$router.push({
          name: 'usImageShow'
        })
      } else if (this.boxIndex == 3) {
        this.$router.push({
          name: 'usVideoShow'
        })
      }
    },
    getShow () {
      this.httphelper
        .post('/api/CGPEnterPriseApi/GetOrganVisitList', {
          orgId: Number(localStorage.getItem('storeId'))
        })
        .then(res => {
          if (res.data.code == 200) {
            for (let i = 0; i < res.data.data.length; i++) {
              if (res.data.data[i].type == 1) {
                this.boxIndex = 2
              } else if (res.data.data[i].type == 2) {
                this.boxIndex = 3
              }
            }
          }
        });
    },
  }
};
</script>

<style scoped>
.toptitle {
    width: 100%;
    height: 57px;
    background: #f6f7fb;
    padding-left: 17px;
    padding-right: 30px;
    margin: 30px 0 40px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
}
.ttleft {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #0b8586;
    line-height: 56px;
}
.ttright {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0b8586;
    display: flex;
    align-items: center;
}
.ttright img {
    margin-right: 8px;
}
.topbox {
    display: flex;
    justify-content: space-between;
}
.topbox .box {
    width: 290px;
    height: 170px;
    background: #ffffff;
    box-shadow: 0px 10px 12px 0px rgba(15, 28, 85, 0.15);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 27px 0;
}
.tblogo {
    width: 70px;
    height: 70px;
    background: #a1a1a1;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.tbtitle {
    display: flex;
    justify-content: center;
    align-items: center;
}
.tbtitle div {
    width: 30px;
    height: 1px;
    background: #a1a1a1;
    border: 1px solid #979797;
    opacity: 0.6;
    box-sizing: border-box;
}
.tbtitle span {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    margin: 0 5px;
}
.top2box {
    margin: 50px 0;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
}
.top3box {
    display: flex;
    justify-content: center;
    margin-top: 50px;
}
.t3box {
    width: 200px;
    height: 40px;
    background: #0b8586;
    border-radius: 20px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
}
</style>